export default{
    actions: {
      
    },
    mutations: {
   
    addpostobmenobvs(state, newpost){
        if(newpost.length) state.postobvsobmen.push(newpost);
        else state.postobvsobmens=newpost;   
    },
    addobmenkateg(state, newpost){
        state.kateg=newpost;
    },
    addobmenrazdel(state, newpost){
        state.razdel=newpost;
    },
    addobmenmarka(state, newpost){
        state.marka=newpost;
    },
    addobmenmodel(state, newpost){
        state.model=newpost;
    },
    addobmentip(state, newpost){
        state.tip=newpost;
    },
    addobmengod(state, newpost){
        state.god=newpost;
    },
    addobmenmy_car(state, newpost){
        state.my_car=newpost;
    },
    
    },
    state: {
       postobvsobmen:[],
        kateg:"",
        razdel:"",
        marka:"",
        model:"",
        god:"",
        tip:"",
        my_car:""

    },
    getters:{
        
        getpostobmenobvs(state){
            return state.postobvsobmen
        }, 
        getobmenkateg(state){
            return state.kateg
        }, 
        getobmenrazdel(state){
            return state.razdel
        },
        getobmenmarka(state){
            return state.marka
        },
        getobmenmodel(state){
            return state.model
        },
        getobmentip(state){
            return state.tip
        },
        getobmengod(state){
            return state.god
        },
        getobmenmy_car(state){
            return state.my_car
        },
        
    }
}